import Heading from '../components/common/Heading';
import LayOut from '../components/common/Layout';
import { Routes } from '../utils/Routes';
import profileImage from '../assets/images/About.png';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <LayOut layoutStyle="bg-white">
      <div className="pt-16 lg:pt-14 pb-16">
        {/* Page Header */}
        <div className="text-center px-4 mb-12">
          <Heading text="About" customStyle="text-custom-coffee" />

          <div className="mx-auto mt-3 w-10 h-px bg-custom-stone" />
        </div>

        {/* Main Content */}
        <div className="container mx-auto px-6 lg:px-24 max-w-xl">
          <div className="flex flex-col items-left text-center space-y-4">
            <p className="text-base text-custom-coffee font-light leading-relaxed">
              Unspoken Creations is a personal expression of art, thoughts,
              music and things.
            </p>
            {/* Profile Image */}
            <div className="w-36 h-36 overflow-hidden shadow-md shrink-0 self-center">
              <img
                src={profileImage}
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>

            <blockquote className="relative pl-4 py-1 text-left">
              <span className="absolute -top-3 -left-1 text-4xl text-custom-stone/50 font-serif leading-none select-none">
                &ldquo;
              </span>
              <p className="text-sm text-gray-300 italic leading-relaxed">
                And words fail me. I have no words.
              </p>
            </blockquote>
            <p className="text-sm text-gray-400 italic self-start">
              - Ethredah
            </p>
            <div className="pt-2 self-start">
              <Link
                to={Routes.Art}
                className="inline-flex items-center gap-1.5 bg-custom-coffee text-white text-sm font-medium rounded-full px-5 py-2 hover:bg-custom-coffee/80 transition-colors duration-200"
              >
                Explore the Art Collection
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3.5 h-3.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </LayOut>
  );
}
